import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  href?: string;
  showIcon?: boolean;
}
export function CTAButton({
  children,
  onClick,
  className = '',
  href,
  showIcon = true
}: CTAButtonProps) {
  const baseClasses = 'inline-flex items-center justify-center px-8 py-4 text-lg font-medium text-white bg-coral rounded-full shadow-lg hover:bg-coral-hover transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-coral focus:ring-offset-cream';
  const content = <div className="flex items-center justify-center w-full" data-id="element-1">
      <div className="flex flex-col items-center justify-center text-center" data-id="element-2">
        {children}
      </div>
      {showIcon && <ArrowRight className="ml-3 w-5 h-5 flex-shrink-0" data-id="element-3" />}
    </div>;
  if (href) {
    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
      if (onClick) onClick();
      // If it's an internal anchor link, handle smooth scrolling
      if (href.startsWith('#')) {
        e.preventDefault();
        const element = document.querySelector(href);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }
    };
    return <motion.a href={href} className={`${baseClasses} ${className}`} onClick={handleClick} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} data-id="element-4">
        {content}
      </motion.a>;
  }
  return <motion.button onClick={onClick} className={`${baseClasses} ${className}`} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} data-id="element-5">
      {content}
    </motion.button>;
}